<template>
  <div class="operation-log-container">
    <el-table :data="logs" height="100%" size="mini">
      <el-table-column
        type="index"
        :align="align"
        width="50"
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="operatorUserName"
        :align="align"
        width="100"
        label="操作人"
      ></el-table-column>
      <el-table-column
        prop="operatorTime"
        :align="align"
        width="180"
        label="操作时间"
      ></el-table-column>
      <el-table-column
        prop="operatorDevice"
        :align="align"
        width="100"
        label="操作设备"
      ></el-table-column>
      <el-table-column
        prop="operatorName"
        :align="align"
        width="100"
        label="操作"
      ></el-table-column>
      <el-table-column
        prop="operatorDescribe"
        :align="align"
        label="日志描述"
      ></el-table-column>
    </el-table>
    <!-- <el-pagination layout="prev, pager, next, total" :total="total">
    </el-pagination> -->
  </div>
</template>

<script>
export default {
  props: {
    waybillSplitId: {},
    waybillNumber: {},
  },
  data() {
    return {
      align: "center",
      logs: [],
      pageNum:1,
      pageTotal:10,
      total:0
    };
  },
  watch: {
    waybillSplitId: {
      handler(val) {
        if (!val) {
          this.logs = [];
        }
        this.getData();
      },
    },
  },
  mounted(){
    this.getData()
  },
  methods: {
    async getData() {
      if(!this.waybillSplitId){
        return;
      }
      const res = await this.$API.wtl_getWaybillOperateLog({
        waybillSplitId: this.waybillSplitId,
      });
      this.logs = res.data.result || [];
    },
  },
};
</script>

<style scoped lang="less">
.operation-log-container {
  height: 100%;
  display: flex;
  flex-flow: column;
}
</style>